import { mapActions } from "vuex";
import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
export const locker = {
  data() {
    return {
      planIdentityId: null,
      lockId: null,
      timer: null,
      dialogs: null,
      dialog: null,
      warning: false,
      builder: false
    };
  },
  async beforeDestroy() {
    console.log("locker: before destroy: ", this.lockId, this.planIdentityId)
    window.removeEventListener("beforeunload", this.beforeUnload, {capture: true});
    // window.removeEventListener("visibilitychange", this.unload, {capture: true});
    await this.unlock();
  },
  watch: {
    dialogs: {
      handler(v) {
        // console.log(v, this.dialog, v[this.dialog])
        if (v && v[this.dialog] === false) this.unlock();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions("plansMembers", ["unlockId", "unlockNoPlan", "unlockBuilder", "unlockPortalProxy"]),
    async lock(apiFunction, options, timeoutCallback, returnStatus, builder, portalProxy) {
      console.log("L O C K: ", options);
      if (builder) {
        this.builder = true;
      }
      if (portalProxy) {
        this.portalProxy = true;
      }
      if (options.planId) this.planIdentityId = options.planId;
      else if (options.plan) this.planIdentityId = options.plan;
      else if (options.planIdentityId) this.planIdentityId = options.planIdentityId;
      else this.planIdentityId = options;
      if (options.dialogs) {
        this.dialogs = options.dialogs;
        this.dialog = options.dialog;
      }
      if (options.warning) {
        this.warning = true;
      }
      ApiService.setLockHeader();
      try {
        const response = await apiFunction(options);
        ApiService.removeHeaders();

        this.setLock(response, timeoutCallback);

        if (returnStatus === true) return response;

        return response.data;
      } catch (error) {
        ApiService.removeHeaders();
        console.error(error);
        if (error.response.status === 409 && error.response.data.Code === 400) {
          this.setLock(error.response, timeoutCallback);
        }
        const lockId = error.response.headers["lock-id"];
        this.unlock(lockId);
        throw error;
      }
    },
    unlock(lockId) {
      console.log("U N L O C K: ", lockId, this.lockId);
      if (lockId) {
        this.lockId = lockId;
      }
      if (this.lockId) {
        clearTimeout(this.timer);
        const lockId = this.lockId;
        this.lockId = null;
        if (this.builder) this.unlockBuilder({ planId: this.planIdentityId, lockId: lockId });
        else if (this.portalProxy) this.unlockPortalProxy({ planId: this.planIdentityId, lockId: lockId });
        else if (this.planIdentityId) this.unlockId({ planId: this.planIdentityId, lockId: lockId });
        else this.unlockNoPlan({ lockId: lockId });
      }
    },
    setLock(response, timeoutCallback) {
      const lockExpires = response.headers["lock-expires"];
      this.lockId = response.headers["lock-id"];
      console.log("locker: set lock:", lockExpires, this.lockId);
      if (this.lockId || this.lockExpires) {
        if (!lockExpires || !this.lockId) {
          let error = new Error();
          error.clientCode = "noLockHeaders";
          timeoutCallback();
          throw error;
        }
        const lockTimeout = Date.parse(lockExpires) - new Date();
        console.log("locker: set lock: lock timeout:", lockTimeout);
        this.timer = setTimeout(() => {
          console.log("locker: set lock: timeout cb: ", timeoutCallback);
          timeoutCallback();
        }, lockTimeout);
      }
    },
    sleep(milliseconds) {
      const date = Date.now();
      let currentDate = null;
      do {
        currentDate = Date.now();
      } while (currentDate - date < milliseconds);
    },
    async unload() {
      // if (document.visibilityState === 'hidden') {
      //   if (this.lockId) {
      //     await this.unlock();
      //     console.log("Hello");
      //     this.sleep(1000);
      //     console.log("World!");
      //   }
      // }
      console.log("locker: unload: ", this.lockId);
      if (this.lockId) {
        await this.unlock();
        console.log("Hello");
        this.sleep(1000);
        console.log("World!");
      }
    },
  },
  created() {
    window.addEventListener("beforeunload", this.unload, {capture: true});
    // window.addEventListener('unload', this.unload, {capture: true});
    // document.addEventListener("visibilitychange",this.unload);
  },

  
  async beforeRouteLeave(to, from, next) {
    console.log("locker: before route leave: ", this.lockId, this.planIdentityId, this.warning);
    if (this.warning) {
      this.displayWarning(next);
    } else {
      await this.unlock();
      // window.removeEventListener("beforeunload", this.beforeUnload, {capture: true});
      window.removeEventListener("visibilitychange", this.unload, {capture: true});
      next();
    }
  },
};
